import { useGetMineCommonMistakes } from './useGetMineCommonMistakes'
import { useGetMineCommonMistakesByProgramInstance } from './useGetMineCommonMistakesByProgramInstance'

export const operators = {
  getMineCommonMistakes: useGetMineCommonMistakes,
  getMineCommonMistakesByProgramInstance: useGetMineCommonMistakesByProgramInstance,
}
